export const getSplittedValue = value => {
  const splittedValue = value.split('-W').map(item => item.replace(/_/g, ''));
  const year = splittedValue[0] ? parseInt(splittedValue[0]) : undefined;
  const week = splittedValue[1] !== '' ? parseInt(splittedValue[1]) : undefined;
  return { year, week };
};
